module.exports = __webpack_public_path__ + "img/img_make.1c2b14a0.jpg";